import { useGetMemberHandicapsQuery } from '../state/api';
import MemberHandicaps from './member-handicaps';

const MemberHandicapsContainer = () => {
  const { data: memberHandicaps = [] } = useGetMemberHandicapsQuery();

  return <MemberHandicaps memberHandicaps={memberHandicaps} />;
};

export default MemberHandicapsContainer;
